<script>
import PageHeader from '@components/page-header'
import NavBar from '@components/nav-bar'
import PageHero from '@components/page-hero'
import PageFooter from '@components/page-footer'
import SearchBar from '@components/search-bar'

export default {
  components: { PageHeader, NavBar, PageHero, PageFooter, SearchBar },

  props: {
    layout: { type: String, required: true },
    layoutComponents: { type: Array, required: true },
    property: { type: Object, required: true },
  },

  data: () => ({
    heroImg: '/images/hero-main.jpg',
  }),

  methods: {
    showComponent(name) {
      return this.layoutComponents.includes(name)
    },
  },
}
</script>

<template>
  <div id="main">
    <PageHeader>
      <NavBar v-if="showComponent('navbar')" />
    </PageHeader>

    <main>
      <PageHero v-if="showComponent('heroImg')" :hero-img="heroImg" />

      <SearchBar v-if="showComponent('searchbar')" />

      <router-view />
    </main>

    <PageFooter :property="property" />

    <router-view name="bottom" />
  </div>
</template>
